import type {SuggestResponse} from "../generated";

export type FallbackResponse = SuggestResponse

export const generateFallbackResponse = (value: string): FallbackResponse => {
  const trackingLabelString = encodeURIComponent(JSON.stringify({
    "wk.san_ActiveSearch": "true",
    "san_InitialSearch": "true",
    "san_Interaction": "initial_search",
    "wk.san_SearchType": "search",
    "wk.san_SuggestPos": "0",
  }));
  return {
    original: {
      term: value,
      visual: value,
      target: `${window.location.origin}/suche/${value}/#t=${trackingLabelString}`,
    },
    keywords: [],
  };
}
